module.exports = __webpack_public_path__ + "static/img/KZ@2x.5027046e.jpg";